import { AtlasBodyMain } from '@justomx/atlas-components'

interface ListMoleculeProps {
  lines: string[]
  ordered?: boolean
}

export const ListMolecule = (props: ListMoleculeProps) => {
  const { lines, ordered = false } = props

  const ListTag = ordered ? 'ol' : 'ul'
  const listStyle = ordered ? 'decimal' : 'disc'

  return (
    <ListTag style={{ paddingLeft: '32px', listStyleType: listStyle }}>
      {lines.map((line, index) => (
        <li key={index}>
          <AtlasBodyMain>{line}</AtlasBodyMain>
        </li>
      ))}
    </ListTag>
  )
}
